import { CircleInfoLined } from "@tag/tag-icons";
import { FC } from "react";
import "./dailyForecastRationale.css";
import dayjs from "dayjs";
import { useForecastContext } from "../../../../context/forecastContext";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import { findForecastForDay } from "../../../../utilities/forecastHelpers";
import { useForecastQuery } from "../../../../services/forecastService";

const DailyForecastRationale: FC = () => {
  const { forecastState } = useForecastContext();
  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="13px" />;
  }

  const forecast = findForecastForDay(
    dayjs(forecastState.selectedDate).format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="daily-forecast-rationale-container">
      <div className="daily-forecast-rationale-header">
        <div className="daily-forecast-rationale-header-title">
          <span>
            <CircleInfoLined accent="teal" /> {"Forecast Rationale"}
          </span>
        </div>
      </div>
      <div className="daily-forecast-rationale-content-container">
        <div className="daily-forecast-rationale-forecastRationale">
          /** Data needs to be provided from backend */
          {/* {forecast.ForecastConfiguration.replace(
            "{SITE}",
            forecastState.selectedSite?.siteName || "Unknown Site"
          ).replace("{WEEKDAY}", forecast.WeekDay)} */}
        </div>
        <div className="daily-forecast-rationale-lastUpdatedBy">
          <div className="daily-forecast-rationale-lastUpdatedBy-label">
            Last Updated by:
          </div>
          <div className="daily-forecast-rationale-lastUpdatedBy-value">
            /** Data needs to be provided from backend */
            {/* {forecast.LastUpdatedBy} */}
          </div>
        </div>
        <div className="daily-forecast-rationale-lastUpdatedDate">
          <div className="daily-forecast-rationale-lastUpdatedDate-label">
            Last updated date:
          </div>
          <div className="daily-forecast-rationale-lastUpdatedDate-value">
            {dayjs(forecast.LastUpdated).format("DD/MM/YYYY")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyForecastRationale;
